<template>
  <v-app>
    <v-app-bar-nav-icon
      @click.stop="drawerState = !drawerState"
    ></v-app-bar-nav-icon>
    <v-navigation-drawer
      v-model="drawerState"
      absolute
      color="#0F4C81"
      dark
      hide-overlay
      mobile-breakpoint="30000"
    >
      <div class="d-flex justify-center mt-2">
        <v-img
          @click="$router.push('/dashboard')"
          class="pointer"
          width="100px"
          height="100px"
          contain
          :src="`../images/logo/${$city.name}/logo.png`"
        ></v-img>
      </div>
      <div class="white--text text-center text-h6 mb-2">
        {{ $city.name }}健康檢查系統
      </div>
      <v-list nav dense>
        <v-list-item-group v-model="selectedItem">
          <v-list-item
            v-for="item of aclMenu"
            :key="item.key"
            @click="doAction(item.key)"
          >
            <v-list-item-title class="text-body-1 py-2 my-2">{{
              item.title
            }}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-main>
      <v-container>
        <router-view />
        <myAccount
          v-model="myAccountDialog"
          @logout="doAction('logout')"
        ></myAccount>
      </v-container>
      <Announcement type="announcementDashboard" />
    </v-main>
  </v-app>
</template>

<script>
const defaultDrawer = false;
import Announcement from "@/components/Common/Announcement.vue";
import myAccount from "@/components/Account/myAccount.vue";
import util from "@/mixins/util";
import ls from "expired-localstorage";
import dayjs from "dayjs";
export default {
  name: "DashboardTemplate",
  components: {
    myAccount,
    Announcement,
  },
  mixins: [util],
  data: () => ({
    selectedItem: 0,
    myAccountDialog: false,
    menu: [
      {
        title: "儀表板",
        key: "main",
        acl: ["管理者", "衛生局管理員", "衛生局", "衛生所管理者", "衛生所"],
      },
      {
        title: "民眾預約修改查詢",
        key: "people",
        acl: [],
      },
      {
        title: "邀約名單下載",
        key: "invite",
        acl: ["管理者", "衛生局管理員", "衛生所管理者"],
      },
      {
        title: "場次設定",
        key: "section",
        acl: [],
      },
      {
        title: "一階報到作業",
        key: "checkin",
        acl: [],
      },

      {
        title: "二階報到作業",
        key: "checkinReport",
        acl: ["管理者", "衛生局管理員", "衛生局", "衛生所管理者", "衛生所"],
      },
      {
        title: "匯入資格名單",
        key: "importList",
        acl: ["管理者"],
      },
      {
        title: "匯入篩檢結果",
        key: "importReport",
        acl: ["管理者", "衛生局管理員", "衛生所管理者", "衛生所"],
      },
      {
        title: "可篩檢快查",
        key: "quickCheck",
        acl: [],
      },
      {
        title: "帳號管理",
        key: "account",
        acl: ["管理者", "衛生局管理員", "衛生所管理者"],
      },
      {
        title: "預約記錄 Log",
        key: "reservationLog",
        acl: ["管理者"],
      },
      {
        title: "System Log",
        key: "systemLog",
        acl: ["管理者"],
      },
      {
        title: "系統設定",
        key: "system",
        acl: ["管理者", "衛生局管理員"],
      },
      {
        title: "我的帳號",
        key: "myAccount",
        acl: [],
      },
      {
        title: "登出",
        key: "logout",
        acl: [],
      },
    ],
  }),
  created() {
    if (this.isOverTime) {
      this.myAccountDialog = true;
      this.$toast.error("密碼過期，請重新設定密碼！");
    } else if (
      this.isOverTimeSoon &&
      (!this.$store.state.warningPWExired ||
        dayjs() < dayjs(this.$store.state.warningPWExired))
    ) {
      this.$store.commit("setState", {
        warningPWExired: dayjs().format("YYYY-MM-DD"),
      });
      this.$toast.warning("密碼即將過期，請重新設定密碼！");
    }

    this.$store.commit("toggleDrawerState", defaultDrawer);
    let key = this.$route.name;
    this.selectedItem = _.findIndex(this.aclMenu, { key });
  },
  computed: {
    drawerState: {
      get() {
        return this.$store.getters.drawerState;
      },
      set(v) {
        return this.$store.commit("toggleDrawerState", v);
      },
    },
    aclMenu() {
      let menu = [...this.menu];
      menu = menu.filter((item) => {
        if (!item.acl.length) return true;
        return item.acl.includes(this.$store.state.user.角色);
      });
      return menu;
    },
  },
  methods: {
    doAction(key) {
      if (key == "logout") {
        ls.remove("token");
        this.$router.push(`/dashboard`);
      } else if (key == "myAccount") {
        this.myAccountDialog = true;
      } else {
        this.$router.push(`/dashboard/${key}`);
      }
    },
  },
  watch: {
    myAccountDialog(value) {
      if (!value) {
        let key = this.$route.name;
        this.selectedItem = _.findIndex(this.aclMenu, { key });
      }
    },
  },
};
</script>
<style lang="scss">
.page-title {
  font-size: 1.125rem;
  margin-bottom: 20px;
}

@media print {
  .v-app-bar-nav-icon,
  .v-app-bar__nav-icon {
    display: none !important;
  }
}
</style>
